import { getLocalStorageValue, setLocalStorageValue } from '~/hooks/use-local-storage';
import { SmartSendFilterContext, SortField, SortOrderField } from './SmartSendFilterApplier';

export type FilterArea = 'DEFAULT' | 'Sold' | 'Grouped' | 'Booked' | 'InTransit';
export type FilterPreference = 'ShowAsGroup' | 'SortField' | 'SortOrder';

const generateKey = (area: FilterArea, setting: string) => `smartsend-${area}-${setting}`.toLowerCase();

export const getAreaEnabledPreference = (
  area: FilterArea,
  setting: FilterPreference,
  defaultValue: boolean
): boolean => {
  const value = getLocalStorageValue(generateKey(area, setting));
  if (value) {
    return value === 'true';
  }
  return defaultValue;
};

export const getAreaStringPreference = (area: FilterArea, setting: FilterPreference, defaultValue: string): string =>
  getLocalStorageValue(generateKey(area, setting)) || defaultValue;

export const getAreaSortFieldPreference = (
  area: FilterArea,
  setting: FilterPreference,
  defaultValue: SortField
): SortField => (getLocalStorageValue(generateKey(area, setting)) || defaultValue) as SortField;

export const getAreaSortOrderFieldPreference = (
  area: FilterArea,
  setting: FilterPreference,
  defaultValue: SortOrderField
): SortOrderField => (getLocalStorageValue(generateKey(area, setting)) || defaultValue) as SortOrderField;

export const setAreaEnabledPreference = (area: FilterArea, setting: FilterPreference, value: boolean) => {
  setLocalStorageValue(generateKey(area, setting), value.toString().toLowerCase());
};

export const setAreaStringPreference = (area: FilterArea, setting: FilterPreference, value: string) => {
  setLocalStorageValue(generateKey(area, setting), value);
};

export const applySmartSendFilterContext = (context: SmartSendFilterContext) => {
  if (context?.CurrentFilter) {
    setAreaEnabledPreference(context.CurrentFilter.Area, 'ShowAsGroup', context.CurrentFilter.ShowAsGroup);
    setAreaStringPreference(context.CurrentFilter.Area, 'SortField', context.CurrentFilter.SortField);
    setAreaStringPreference(context.CurrentFilter.Area, 'SortOrder', context.CurrentFilter.SortOrder);
  }
};
